/* eslint-disable jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useEffect, useState } from 'react';
import { DatePicker } from '@americanexpress/dls-react';
import OverflowItem from '../../../OverflowItem';
import DatePickerInput from './DatePickerInput';

function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

function formatDate(date) {
  return [
    date.getFullYear(),
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
  ].join('-');
}

const isStringDateValid = (dateString) => import(/* webpackChunkName: 'moment' */ 'moment').then(
  ({ default: moment }) => moment(dateString, 'MM/DD/YYYY', true).isValid()
);

const DatePickerFilterComponent = React.memo((props) => {
  const {
    header, filters, colIdx, filter, setFilter, onKeyPress, tableNm, isDisable,
  } = props;

  const [labelComponentClicked, setLabelComponentClicked] = useState(null);
  const [datePickerValue, setDatePickerValue] = useState('');
  const [datePickerStatus, setDatePickerStatus] = useState('default');

  const saveFilter = (fil) => {
    const newFilters = [...filters];
    newFilters[colIdx] = fil;
    setFilter(newFilters);
    onKeyPress({
      key: 'Enter',
      filters: newFilters,
    });

    console.log('saveFilter');

    console.log(datePickerValue);

    if (!fil || fil === '') {
      setDatePickerValue('');
    } else {
      setLabelComponentClicked(false);
    }
  };

  const overflowStyle = {
    '.overFlowPopUpVisible': {
      background: 'white',
      border: 'solid 1px',
      borderRadius: '6px',
      borderColor: 'lightgrey',
      padding: '0.5rem',
      height: '100px !important',
      width: '300px !important',
    },
  };

  const onDateChange = (event, date) => {
    setDatePickerStatus('default');
    if (!date?.dateString?.match(/[^\d/]/)) {
      setDatePickerValue(date?.dateString);
      isStringDateValid(date?.dateString).then((result) => {
        if (result) {
          // Check to make sure that manually inputted date is not over the allowed dates
          if (!header?.allowFutureDates) {
            const selectedDate = new Date(new Date(date.dateString).setHours(0, 0, 0));
            const todaysDate = new Date(new Date().setHours(0, 0, 0));
            if (selectedDate.valueOf() > todaysDate.valueOf()) {
              setDatePickerStatus('error');
              saveFilter('');
              return;
            }
          }
          saveFilter(date?.dateString);
        }
      });
    }
  };

  useEffect(() => {
    const getDate = (date) => ({ dateString: date });
    if (filter !== '') {
      // Saved filter validation to ensure accurate dates
      if (!datePickerValue) {
        onDateChange(undefined, getDate(filter));
      }
    } else {
      console.log('saveFilter #2');
      setDatePickerValue('');
    }
  }, [filter]);

  return (
    <div>
      <OverflowItem
        id={`${tableNm}-${header?.id}-overflowItem`}
        theme={overflowStyle}
        isLabelComponentClicked={labelComponentClicked}
        isDisable={isDisable}
        labelComponent={(
          <DatePickerInput
            id={`${tableNm}-${header?.id}-datePickerInput`}
            value={filter}
            placeholder={header?.label}
            calendarClosed={false}
            onButtonClick={() => {}}
            calendarButtonLabel={`${tableNm}-${header?.id}-datePickerCalenderButton`}
            dateIconFilled={true}
            isDisable={isDisable}
          />
)}
      >
        <div>
          <div
            id={`${tableNm}-${header?.id}-clearDateFilterContainer`}
            className="flex"
            style={{ justifyContent: 'end' }}
          >
            <a
              id={`${tableNm}-${header?.id}-clearDateFilter`}
              onClick={() => saveFilter('')}
            >Clear
            </a>
          </div>
        </div>
        <DatePicker
          id={`${tableNm}-${header?.id}-drpicker`}
          date={datePickerValue}
          placeholder="MM/DD/YYYY"
          buttonLabels={{
            calendarButton: `${tableNm}-${header?.id}-drpicker-button`,
            previousMonth: `${tableNm}-${header?.id}-drpicker-prevMonth`,
            nextMonth: `${tableNm}-${header?.id}-drpicker-nextMonth`,
          }}
          describedBy={`${tableNm}-${header?.id}-drpicker-input`}
          status={datePickerStatus}
          onDateChange={onDateChange}
          maxDate={header?.allowFutureDates ? '' : formatDate(new Date())}
        />

      </OverflowItem>
    </div>
  );
});

export default DatePickerFilterComponent;
